<template>
  <div class="form-group" :class="{'input-box': showInputBox}">
    <span v-if="showLabel">
      <!-- /input-group -->
      <i
        v-if="addEmailNotification"
        class="glyphicon glyphicon-envelope"
        v-tooltip="'Email might be generated'"
        title="Email might be generated"
      >
      </i>
      <label :class="{ 'text-danger': hasErrors(getFieldName) }" v-html="label"></label>
      <comments v-if="addComment" :field-name="getCommentfieldName" :model-name="modelName"></comments>
      <br />
      <small class="form-text text-muted" v-if="subtext">
        {{ subtext }}
      </small>
    </span>
    <div class="input-group">
      <input
        type="text"
        ref="numberinput"
        class="form-control"
        v-model.number="inputVal"
        @keypress="removeInvalidChars($event)"
        @change="removeInvalidChars($event)"
        :name="getFieldName"
        :disabled="getIsReadOnly"
        :data-vv-as="label"
        :min="min"
        :max="max"
        v-bind="$attrs"
        v-validate.immediate="vvalidate"
      />
      <div class="input-group-btn">
        <button
          type="button"
          class="btn btn-default"
          :class="{ disabled: getIsReadOnly }"
          @click="getIsReadOnly ? '' : decrease()"
        >
          -
        </button>
        <button
          type="button"
          class="btn btn-default"
          :class="{ disabled: getIsReadOnly }"
          @click="getIsReadOnly ? '' : increase()"
        >
          +
        </button>
      </div>
      <!-- /btn-group -->
    </div>

    <span v-show="errors.has(getFieldName)" class="text-danger">{{ errors.first(getFieldName) }}</span>

    <div v-show="hasErrors(getFieldName)">
      <span
        v-for="(error, index) in errorsFor(getFieldName)"
        class="text-danger"
        :key="`error_${getFieldName}_${index}`"
      >
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script>
import CustomInputMixin from './CustomInputMixin'

export default {
  name: 'NumberInput',
  mixins: [CustomInputMixin],
  inheritAttrs: false,
  props: {
    defaultValue: Number,
    isFloat: { type: Boolean, default: false },
    step: Number,
    decimalPlaces: { type: Number },
    min: { type: Number, default: 0 },
    max: { type: Number, default: Infinity },
  },
  methods: {
    increase: function () {
      let val = this.inputVal
      if (isNaN(val) || val == null) {
        val = 0
      }
      this.inputVal = val + parseFloat(this.getStep) > this.max ? val : val + parseFloat(this.getStep)
    },
    decrease: function () {
      let val = this.inputVal
      if (isNaN(val) || val == null) {
        val = 0
      }
      this.inputVal = val - parseFloat(this.getStep) < this.min ? this.min : val - parseFloat(this.getStep)
    },
    removeInvalidChars: function (event) {
      // 0 for null values
      // 8 for backspace
      // 46 for dot (.) if we allow for decimals
      // 48-57 for 0-9 numbers
      let allowedChars = [0, 8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57]
      if (this.isFloat) {
        allowedChars.push(46)
      }
      if (!allowedChars.includes(event.which)) {
        event.preventDefault()
      }
    },
  },
  computed: {
    getStep: function () {
      return this.step || (this.isFloat ? 0.1 : 1)
    },
    getDecimalPlaces: function () {
      // default to one decimal place because we're only using this for floats
      return this.decimalPlaces || (String(this.getStep).split('.')[1] || '1').length
    },
    inputVal: {
      get() {
        let val = parseFloat(this.getFieldValue(this.getFieldName, this.modelName))
        return isNaN(val) ? null : val
      },
      set(val) {
        let value

        if (val == '') {
          value = val
        } else {
          value = this.isFloat ? parseFloat(val).toFixed(this.getDecimalPlaces) : parseInt(val)
        }
        if (isNaN(value)) {
          value = ''
        }
        let payload = {
          fieldName: this.getFieldName,
          value: value,
          modelName: this.modelName,
        }

        this.setFieldValue(payload)
        this.$emit('on-change', payload)
      },
    },
  },
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}
</style>
